//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import logoImg from '@/assets/logo/logo.png';
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      title: '管理系统',
      logo: logoImg
    };
  }
};